import { Map, AdvancedMarker, MapCameraChangedEvent } from '@vis.gl/react-google-maps';
// import s from '../../../venues/pages/VenuesMap/Map.module.scss'
import s from './AboutMap.module.scss';
import { useEffect, useMemo, useState } from 'react';
import { ReactComponent as GooglePoint } from 'images/new-icons/google-point.svg';

type Poi = { key: string; location: google.maps.LatLngLiteral; price: number; avatar?: string };

const AboutMap = ({ data, setDistances }) => {
  const [userLocation, setUserLocation] = useState<google.maps.LatLngLiteral | null>(null);

  const locations = useMemo(() => {
    return data?.map(item => ({
      key: item?.salon?.id,
      location: {
        lat: item?.salon?.latitude || 0,
        lng: item?.salon?.longitude || 0,
      },
      avatar: item?.salon?.avatar,
    }));
  }, [data]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        error => {
          console.error('Ошибка при получении местоположения:', error);
          setUserLocation({ lat: 25.0933903, lng: 55.153731 });
        },
      );
    } else {
      console.error('Geolocation API не поддерживается этим браузером');
      setUserLocation({ lat: 25.0933903, lng: 55.153731 });
    }
  }, []);

useEffect(() => {
  if (!window.google?.maps) return;  

  if (userLocation && locations?.length > 0) {
    const calculatedDistances = locations.map(poi => {
      const distance = window.google.maps.geometry.spherical.computeDistanceBetween(
        new window.google.maps.LatLng(userLocation.lat, userLocation.lng),
        new window.google.maps.LatLng(poi.location.lat, poi.location.lng)
      );
      return { id: poi.key, distance: distance / 1000 };
    });
    setDistances(calculatedDistances);
  }
}, [userLocation, locations]);


  return (
    <div className={s.map}>
      <Map
        defaultZoom={15}
        defaultCenter={locations?.[0]?.location || { lat: 0, lng: 0 }}
        mapId={'661e50b2cb212eb1'}
        zoomControl={false}
        scaleControl={false}
        streetViewControl={false}
        mapTypeControl={false}
        fullscreenControl={false}
      >
     {window.google?.maps && locations?.map(poi => (
  <AdvancedMarker key={poi.key} position={poi.location}>
    <div className={s.custom_marker}>
      <GooglePoint className={s.marker_pin} />
      <div className={s.avatar_container}>
        <img src={poi.avatar || 'default-avatar-url.png'} alt="Salon location" />
      </div>
    </div>
  </AdvancedMarker>
))}
      </Map>
    </div>
  );
};
export default AboutMap;
